import React from 'react';
import { useMatters } from 'pages/matters/useMatters';
import { MatterResultItem } from './MatterResultItem';
import { StyledMatterList } from '.';

export function FilteredMatters({ filter, byRecent, selected, setSelected }) {
  const matters = useMatters(byRecent);

  const filteredMatters = React.useMemo(() => {
    return !filter
      ? matters
      : matters.filter(matter => {
          const filterBy = [matter.name, matter.client.name];
          const hasMatch = filterBy.reduce((matched, value) => {
            try {
              const pattern = new RegExp(filter, 'i');
              return matched ? matched : value.match(pattern) !== null;
            } catch (error) {
              console.error(error);
              return matched;
            }
          }, false);
          return hasMatch && matter;
        });
  }, [matters, filter]);

  return (
    <StyledMatterList>
      {filteredMatters.map(matter => {
        return (
          <MatterResultItem
            key={matter.id}
            matter={matter}
            setSelected={setSelected}
            selected={selected}
          />
        );
      })}
    </StyledMatterList>
  );
}
